module.exports = __webpack_public_path__ + "media/המבורגר.278d258d.mp3";